/// FOURJS_START_COPYRIGHT(D,2017)
/// Property of Four Js*
/// (c) Copyright Four Js 2017, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("StackLayoutWidgetBase", ["WidgetGroupBase", "WidgetFactory"], function (context, cls) {
  /**
   * @class StackLayoutWidgetBase
   * @memberOf classes
   * @extends classes.WidgetGroupBase
   */
  cls.StackLayoutWidgetBase = context.oo.Class(cls.WidgetGroupBase, function ($super) {
    return /** @lends classes.StackLayoutWidgetBase.prototype */ {
      __name: "StackLayoutWidgetBase",

      /**
       * @inheritDoc
       */
      constructor: function (opts) {
        $super.constructor.call(this, opts);
        this.addClasses("g_StackLayoutEngine");
      },

      _initLayout: function () {
        this._layoutInformation = new cls.LayoutInformation(this);
        this._layoutEngine = new cls.StackLayoutEngine(this);
      },

      _addChildWidgetToDom: function (widget, position) {
        const widgetHost = document.createElement("div");
        widgetHost.classList.add("g_StackElement");
        widget.getLayoutInformation().setHostElement(widgetHost);
        const stackLabel = cls.WidgetFactory.createWidget("StackLabel", this.getBuildParameters());
        widgetHost.appendChild(stackLabel._element);
        widget.getLayoutInformation()._stackLabel = stackLabel;
        widgetHost.appendChild(widget._element);
        this.getLayoutEngine().registerChild(widget, position);
        cls.DOMElementHelper.insertAt(widgetHost, position, this._containerElement);
      },

      _removeChildWidgetFromDom: function (widget) {
        this.getLayoutEngine().unregisterChild(widget);
        const info = widget.getLayoutInformation();
        let host = info && info.getHostElement();
        const label = info && info._stackLabel;
        if (label) {
          label.destroy();
          info._stackLabel = null;
        }
        if (host && host.parentNode === this._containerElement) {
          widget._element.remove();
          host.remove();
          host = null;
        }
      },

      setStackLabelText: function (widget, text) {
        const info = widget.getLayoutInformation(),
          label = info && info._stackLabel;
        if (label) {
          label.setText(text);
        }
      }
    };
  });
});
